import { Agency } from "@adgate/common/types/agency.type";
import { BaseObject } from "@adgate/common/types/base-object.type";
import { CommercialOffice } from "@adgate/common/types/commercial-office.type";
import { Role } from "@adgate/modules/admin/types/role.type";

export class User extends BaseObject
{
    public static TYPE_OFFICE:number         = 1;
    public static TYPE_AGENCY:number         = 2;
    public static TYPE_MULTI:number          = 3;

    fullName!: string;
    email!: string;
    password!: string;
    type!: number;
    locked!: boolean;
    mustChangePassword!: boolean;
    authMethod!: number;
    lastLogin!: number;
    office!: CommercialOffice;
    agency!: Agency;
    roles: Role[];

    constructor()
    {
        super();
        this.type = 3;
        this.roles = [];
    }
}